import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  InformationCircleIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";

const toastIcons = {
  info: <InformationCircleIcon aria-hidden="true" className="size-6 text-info" />,
  success: <CheckCircleIcon aria-hidden="true" className="size-6 text-success" />,
  warning: <ExclamationCircleIcon aria-hidden="true" className="size-6 text-warning" />,
  error: <XCircleIcon aria-hidden="true" className="size-6 text-danger" />,
};

export default toastIcons;
